import React from 'react';
import Icon from '../../../components/AppIcon';

const RevenueForecastPanel = ({ forecast, formatCurrency }) => {
  const getConfidenceColor = (confidence) => {
    switch (confidence) {
      case 'high': return 'text-emerald-600 bg-emerald-50 border-emerald-200';
      case 'medium': return 'text-amber-600 bg-amber-50 border-amber-200';
      case 'low': return 'text-red-600 bg-red-50 border-red-200';
      default: return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
          Revenue Forecast
        </h2>
        <Icon name="BarChart3" size={20} className="text-gray-400" />
      </div>

      <div className="space-y-4">
        {Object?.entries(forecast)?.map(([quarter, data]) => (
          <div key={quarter} className="border border-gray-200 dark:border-slate-700 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase">
                  {quarter} 2026
                </h3>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {data?.deals} deals in pipeline
                </p>
              </div>
              <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${getConfidenceColor(data?.confidence)}`}>
                {data?.confidence?.toUpperCase()}
              </span>
            </div>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-bold text-gray-900 dark:text-white">
                {formatCurrency(data?.expected)}
              </span>
              <span className="text-xs text-gray-500 dark:text-gray-400">expected</span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700">
        <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
          <Icon name="TrendingUp" size={16} />
          <span>Forecast based on deal probability, historical close rates, and seasonal patterns</span>
        </div>
      </div>
    </div>
  );
};

export default RevenueForecastPanel;